import React from 'react';

interface IProps {
  fillColor?: string;
}

const MoveLeftIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.53516 16.1198L1.53516 0.767608C1.53516 0.34367 1.19149 0 0.767549 0C0.343611 0 -5.91278e-05 0.34367 -5.91278e-05 0.767608L-5.91278e-05 16.1198C-5.91278e-05 16.5437 0.343611 16.8874 0.767549 16.8874C1.19149 16.8874 1.53516 16.5437 1.53516 16.1198Z" fill={props.fillColor ?? "#424C57"}/>
      <path d="M3.07043 6.13943L3.07043 10.7451C3.07043 11.381 3.58594 11.8965 4.22185 11.8965L15.736 11.8965C16.3719 11.8965 16.8874 11.381 16.8874 10.7451V6.13943C16.8874 5.50352 16.3719 4.98802 15.736 4.98802L4.22185 4.98802C3.58594 4.98802 3.07043 5.50352 3.07043 6.13943Z" fill={props.fillColor ?? "#424C57"}/>
    </svg>
  )
}

export default MoveLeftIcon;
